<!--
 * @Author: Damon
 * @Date: 2020-09-21 10:58:33
 * @LastEditors: damon
 * @LastEditTime: 2023-06-29 08:29:10
 * @Description: file content
-->
<template>
    <el-button v-if='hasPerms(perms)' :size="size" :type="type" :loading="loading" :disabled="!hasPerms(perms)" @click="handleClick">
        <el-link :icon="icon"  type="primary" :size='size' ></el-link>
    </el-button>
</template>

<script>
import { hasPermission } from '@/utils/auth';

export default {
    name: 'DButtonIcon',
    props: {
        label: { // 按钮显示文本
            type: String,
            default: 'Button',
        },
        icon: { // 显示文本
            type: String,
            default: 'el-icon-edit',
        },
        size: { // 按钮尺寸
            type: String,
            default: 'mini',
        },
        type: { // 按钮类型
            type: String,
            default: null,
        },
        loading: { // 按钮加载标识
            type: Boolean,
            default: false,
        },
        disabled: { // 按钮是否禁用
            type: Boolean,
            default: false,
        },
        link: {
            type: Boolean,
            default: false,
        },
        linkurl: {
            type: String,
            default: '',
        },
        perms: { // 按钮权限标识，外部使用者传入
            type: String,
            default: null,
        },
    },
    data() {
        return {};
    },
    methods: {
        handleClick() {
            // 按钮操作处理函数
            this.$emit('click', {});
        },
        hasPerms(perms) {
            //   return false;
            if (perms !== null && perms !== '') {
                return hasPermission(this.$route.path, perms) && !this.disabled;
            }
            return true;
            // 根据权限标识和外部指示状态进行权限判断
            // return hasPermission(perms) && !this.disabled;
        },
    },
    mounted() {},
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Button/DButtonIcon.vue